/* 布局 */
//前台
import Layout from "@views/layout";

const cooperatebusinesscolumnlinkRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "cooperatebusinesscolumnlink",
            name: "COOPERATEBUSINESSCOLUMNLINK",
            meta: {
                title: "",
                sort: 1,
            },
            component: () => import("@views/business/cooperatebusinesscolumnlink/index.vue"),
            redirect: {
                name: "COOPERATEBUSINESSCOLUMNLINK_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "COOPERATEBUSINESSCOLUMNLINK_LIST",
                    meta: {
                        title: "",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/cooperatebusinesscolumnlink/list.vue"),
                },
                                {
                    path: "add",
                    name: "COOPERATEBUSINESSCOLUMNLINK_ADD",
                    meta: {
                        title: "新增合作-企业-栏目-链接",
                        parentPath: '/business/cooperatebusinesscolumnlink/list',
                        operate: true,
                    },
                    component: () => import("@views/business/cooperatebusinesscolumnlink/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "COOPERATEBUSINESSCOLUMNLINK_EDIT",
                    meta: {
                        title: "编辑合作-企业-栏目-链接",
                        parentPath: '/business/cooperatebusinesscolumnlink/list',
                        operate: true,
                    },
                    component: () => import("@views/business/cooperatebusinesscolumnlink/form.vue"),
                },
                                        ],
    },


        ],
};

export default cooperatebusinesscolumnlinkRouter;
